/**
 * Unauthorized Page
 * Se muestra cuando el usuario no tiene permisos para acceder a una página.
 *
 * HIPAA Requirement: 45 CFR 164.308(a)(4) - Information Access Management
 */
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { usePermissions } from "../../context/PermissionsContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = usePermissions();

  const from = location.state?.from?.pathname || "/Main";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 450,
          textAlign: "center",
        }}
      >
        <LockOutlinedIcon
          sx={{ fontSize: 80, color: "warning.main", mb: 2 }}
        />

        <Typography variant="h4" gutterBottom>
          Acceso Denegado
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          No tienes permisos para acceder a esta seccion.
          {from !== "/Main" && (
            <>
              <br />
              <strong>Ruta solicitada:</strong> {from}
            </>
          )}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Tu rol actual: <strong>{userRole || "No definido"}</strong>
        </Typography>

        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 3 }}>
          Si crees que deberias tener acceso, contacta al administrador del sistema.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => navigate("/Main")}
          >
            Ir al Inicio
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            Volver
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
